/**
 * Converts a string to Header Case (capitalizing the first letter of each word).
 * Handles various string formats, including camelCase and snake_case.
 *
 * @param {string} str - The input string to be transformed.
 * @returns {string} - Transformed Header Case string.
 */
export const getHeaderCase = (str = ''): string => {
  // Early return for non-strings or empty strings
  if (typeof str !== 'string' || !str.trim().length) {
    return '';
  }

  return (
    str
      // Split camelCase, replace sequences of non-alphanumeric characters,
      // and multiple underscores with a space
      .replace(/([a-z])([A-Z])|[^A-Za-z0-9]+|_+/g, (_, p1, p2) => (p1 ? `${p1} ${p2}` : ' '))
      // Convert the entire string to lowercase
      .toLowerCase()
      // Capitalize the first character of each word
      .replace(/\b\w/g, match => match.toUpperCase())
      // Trim any leading or trailing spaces
      .trim()
  );
};
